import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';

@Component({
  selector: 'app-capabilities-navcard',
  imports: [CommonModule, RouterLink],
  standalone: true,
  templateUrl: './capabilities-navcard.component.html',
  styleUrl: './capabilities-navcard.component.scss'
})
export class CapabilitiesNavcardComponent {
  @Output() close = new EventEmitter<void>();

  constructor(private router: Router) {}

  closeCard() {
    this.close.emit();
  }

  navigateTo(path: string) {
    this.close.emit();
    this.router.navigate([`/${path}`]);
  }

}
